import { renderSection } from '@/components/_headers/_shared/renderSection'
import type { CosmicHeaderSection } from '@/lib/cms/cosmic/types/CosmicHeaderType'

export const MobileMenuSubMenu = ({
  leftSection,
  rightSection,
}: {
  leftSection?: CosmicHeaderSection
  rightSection?: CosmicHeaderSection
}) => (
  <div>
    {leftSection && (
      <div>{renderSection({ section: leftSection, isMobile: true })}</div>
    )}
    {rightSection && (
      <div>{renderSection({ section: rightSection, isMobile: true })}</div>
    )}
  </div>
)
